import { getCookie, setCookie } from 'cookies-next';

import { isServer } from './common';

export enum TokenKey {
  TOKEN = 'token',
  REFRESH_TOKEN = 'refreshToken',
}

export const setToken = (key: TokenKey, value: string) => {
  // Ensure this runs only in the browser
  if (isServer) {
    return;
  }
  setCookie(key, value);
};

export const getToken = (key: TokenKey) => {
  return getCookie(key);
};
